import { Popover, Tooltip } from 'antd';
import React from 'react';
import { tooltipTheme } from './tooltip_theme';

export const TooltipH = (props) => {
  const {
    title,
    mobileOff = false,
    placement = 'top',
    className,
    popupClassName = 'x_popover_popup',
    overlayClassName,
    children,
    ...rest
  } = { ...props };

  const resolvedOverlayClassName = overlayClassName || popupClassName;

  const tooltip = (
    <Tooltip
      title={title}
      placement={placement}
      className={className}
      overlayClassName={resolvedOverlayClassName}
      {...tooltipTheme}
      {...rest}
    >
      {children}
    </Tooltip>
  );

  return <>{mobileOff ? <><span className='mobile_v_yes'>{children}</span><span className='mobile_v_no'>{tooltip}</span></> : tooltip}</>
}


export const PopoverH = (props) => {
  const {
    title,
    placement = 'top',
    className,
    mobileOff = false,
    classNames,
    overlayClassName,
    popupClassName = 'x_popover_popup',
    rootClassName,
    children,
    ...rest
  } = { ...props };

  const resolvedOverlayClassName = [
    overlayClassName,
    rootClassName,
    popupClassName,
    typeof classNames === 'string' ? classNames : classNames?.root,
  ].filter(Boolean).join(' ') || undefined;

  const popover = (
    <Popover
      title={title}
      placement={placement}
      className={className}
      overlayClassName={resolvedOverlayClassName}
      autoAdjustOverflow
      {...tooltipTheme}
      {...rest}
    >
      {children}
    </Popover>
  );

  return <>{mobileOff ? <><span className='mobile_v_yes'>{children}</span><span className='mobile_v_no'>{popover}</span></> : popover}</>
}
